
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';

interface CancelClipExportParams {
  clipId: number;
}

const useCancelClipExportMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ clipId }: CancelClipExportParams) => {
      await del(`/v1.0/clips/${clipId}/export`);
    },
    gcTime: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clips'] });
    }
  });
}

export default useCancelClipExportMutation;
